import { Grid, Typography } from '@material-ui/core';
import { useScrollButtonState } from '@ncr-retail/hooks';
import React from 'react';
import { IItemLookup } from 'src/common/interfaces/dtos/IItemLookup';
import { useTranslation } from 'react-i18next';
import Pagination from 'src/pagination/pagination';
import TareWeightSetting from './tare-weight-setting';
import { styles } from './tare-weight-setting-styles';
import { ScrollOrientation } from 'src/common/enumerations/scroll-orientation';
import { HORIZONTAL } from '@ncr-retail/hooks/build/useScrollButtonState/useScrollButtonState';

interface ITareWeightForm {
  linkedGroupItems: IItemLookup[];
  onSelectProduct: (product: IItemLookup) => Promise<void>;
}

export const TareWeightForm = (props: ITareWeightForm): JSX.Element => {
  const classes = styles();
  const { t } = useTranslation();

  const [
    { currentPage, lastPage, onPageChanged, navScrollLeftEnabled, navScrollRightEnabled },
    scrollRef,
  ] = useScrollButtonState(props.linkedGroupItems.length, false, HORIZONTAL);
  return (
    <Grid container className={`${classes.tareWeightBox} ${classes.gridContainerSpacing}`}>
      <Grid container item xs={12} className={classes.tareWeightBoxContainer}>
        <Grid item container xs={9}>
          <Typography className={classes.subHeading}>{t('SelectTareWeight')}</Typography>
        </Grid>
      </Grid>
      <Grid container xs={12}>
        <Grid
          container
          ref={scrollRef}
          spacing={2}
          item
          xs={11}
          className={`horizontalScroll ${classes.containerSpacing} ${classes.tareWeightContainer}`}
        >
          {props.linkedGroupItems.map(
            (item): JSX.Element => (
              <TareWeightSetting
                product={item}
                key={item.itemId}
                onSelectProduct={props.onSelectProduct}
              />
            ),
          )}
        </Grid>
        <Grid item container xs={1} className={classes.pagination}>
          <Pagination
            currentPage={currentPage}
            totalPages={lastPage}
            updateCurrentPageHandler={onPageChanged}
            testIdPrefix={'tare-weight'}
            displayText={false}
            canScrollUp={navScrollLeftEnabled}
            canScrollDown={navScrollRightEnabled}
            scrollOrientation={ScrollOrientation.Horizontal}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};
